/**
 * Messages for one area of the app (document 15, section 5.1), English and Arabic side by side.
 * Every key lives under `purchasePages`; Arabic plurals have all six CLDR forms.
 */
import * as banking from './purchasePagesParts/banking.js';
import * as documents from './purchasePagesParts/documents.js';
import * as lists from './purchasePagesParts/lists.js';
import * as reconcile from './purchasePagesParts/reconcile.js';

export const en = {
  purchasePages: { ...documents.en, ...lists.en, ...banking.en, ...reconcile.en },
};

export const ar = {
  purchasePages: { ...documents.ar, ...lists.ar, ...banking.ar, ...reconcile.ar },
};
